import { combineReducers } from 'redux';
import authReducer from './authReducer';
import reportReducer from './reportReducer';
import projectReducer from './projectReducer';
import accountReducer from './accountReducer';
import dbReducer from './dbReducer';
import validationReducer from './validationReducer';
import driveReducer from './dRiveReducer';

const combineReducer = combineReducers({
  authR: authReducer,
  reportR: reportReducer,
  projectR: projectReducer,
  accountR: accountReducer,
  databaseR: dbReducer,
  validateR: validationReducer,
  driveR: driveReducer,
});

export default combineReducer;
